<template>
<span class="d-flex">
	<menu-icon
		name="station_manage"
		color="currentColor"
		edge-size="18"
		class="me-2"
	/>
	Користувач "<span class="fw-bolder">{{ getUserName(user_id) ?? 'невідомий (видалений)' }}</span>" встановив
</span>
<p class="paragraph-indent">
	{{ parameter }} = {{ value }}
</p>
</template>



<script>
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { useAccounts } from '@/composables/accounts.js'


export default {
	components: {
		MenuIcon,
	},

	props: {
		user_id: {
			type: String,
			required: true,
		},

		parameter: {
			type: String,
			required: true,
		},
		
		value: {
			type: String,
			required: true,
		},
	},

	setup() {
		const { getUserName } = useAccounts()
		return {
			getUserName,
		}
	},
}
</script>